module.exports = __webpack_public_path__ + "img/flight_icon.3f76d714.png";